<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget @tab="switchTab" activeTab="movies" />

      <div class="tab-options">
        <b-button type="is-primary" @click="newMovieModal = true" v-if="currentTab == 1">NEW MOVIE</b-button>
        <b-button type="is-primary" @click="newSerieModal = true" v-else>NEW SERIES</b-button>
      </div>
    </div>
    <div class="wrapper-body movies_body" :class="{ activeSide: $store.state.sidebar }">
      <endmovies @closeModal="newMovieModal = false" :showModal="newMovieModal" @edit="edit($event, 'movie')"
        @changeTab="currentTab = $event" v-if="currentTab == 1" />
      <tvseries @closeModal="newSerieModal = false" @edit="edit($event, 'serie')" :showModal="newSerieModal"
        @changeTab="currentTab = $event" v-if="currentTab == 2" />
    </div>

  </div>
</template>

<script>

import dataCard from './components/dataCard.vue';
import Endmovies from './components/endmovies.vue';
import Tvseries from './components/tvseries.vue';
import TabsWidget from './components/TabsWidget.vue';
export default {
  data() {
    return {
      toggleModal: false,
      modalToToggle: 'movie',
      // selected_data: null,
      currentTab: 1,
      newMovieModal: false,
      newSerieModal: false,
    }
  },
  components: { dataCard, Endmovies, Tvseries, TabsWidget },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    // edit(data, modal) {
    //   let vm = this;
    //   vm.selected_data = data
    //   vm.modToggle(modal)
    // },
    // modToggle(modal) {
    //   let vm = this;
    //   vm.modalToToggle = modal,
    //   vm.toggleModal = true
    // }
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: fit-content;
    // height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    padding-left: 6px;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: grid;
    padding: 0px 0 15px;
    column-gap: 20px;
    row-gap: 50px;
    overflow-y: auto;
  }
}
</style>
